var map = {
	"./images/beauty/overview01.png": 7266,
	"./images/beauty/overview02.png": 3902,
	"./images/beauty/overview03.png": 5480,
	"./images/beauty/overview04.png": 5917,
	"./images/beauty/overview05.png": 484,
	"./images/bg.png": 4145,
	"./images/data01.png": 4165,
	"./images/data02.png": 6916,
	"./images/data03.png": 8907,
	"./images/data04.png": 849,
	"./images/data05.png": 6431,
	"./images/dialog.png": 2944,
	"./images/dialog/bg.png": 3474,
	"./images/dialog/hot.png": 9004,
	"./images/dialog_video.png": 3014,
	"./images/dialog_wrap.png": 2392,
	"./images/goods/bg.png": 1157,
	"./images/goods/bg02.png": 7829,
	"./images/goods/bg03.png": 9430,
	"./images/goods/detail.png": 8240,
	"./images/goods/dialog.png": 2919,
	"./images/goods/hot.png": 780,
	"./images/goods/icon01.png": 3460,
	"./images/goods/icon02.png": 5635,
	"./images/goods/icon03.png": 9621,
	"./images/goods/icon04.png": 8,
	"./images/goods/map/point01.png": 5601,
	"./images/goods/map/point02.png": 3241,
	"./images/goods/map/point03.png": 5938,
	"./images/goods/map/point04.png": 741,
	"./images/goods/name.png": 5676,
	"./images/goods/price.png": 4105,
	"./images/goods/tip.png": 6275,
	"./images/goods/top01.png": 583,
	"./images/goods/top02.png": 6797,
	"./images/goods/top03.png": 3383,
	"./images/goods/weight.png": 6043,
	"./images/header.png": 1167,
	"./images/home/bg.png": 1077,
	"./images/home/data01.png": 3527,
	"./images/home/data02.png": 5583,
	"./images/home/data03.png": 5099,
	"./images/home/data04.png": 7502,
	"./images/home/data05.png": 9047,
	"./images/home/data06.png": 8613,
	"./images/home/data07.png": 6643,
	"./images/home/data_bg.png": 6434,
	"./images/home/data_bg01.png": 9816,
	"./images/home/hot01.png": 3913,
	"./images/home/hot02.png": 5804,
	"./images/home/hot03.png": 1969,
	"./images/home/left_bg-bottom.png": 9223,
	"./images/home/left_bg-text.png": 575,
	"./images/home/left_bg.png": 8442,
	"./images/home/left_content.png": 7,
	"./images/home/left_item01.png": 4095,
	"./images/home/left_item02.png": 875,
	"./images/home/left_item03.png": 7933,
	"./images/home/left_item04.png": 5703,
	"./images/home/left_logo.png": 3287,
	"./images/home/travel01.png": 5306,
	"./images/home/travel02.png": 8962,
	"./images/home/travel03.png": 6614,
	"./images/investment/bg.png": 1835,
	"./images/investment/bg01.png": 9111,
	"./images/investment/contact01.png": 7009,
	"./images/investment/contact02.png": 8753,
	"./images/investment/detail01.png": 979,
	"./images/investment/detail02.png": 5885,
	"./images/investment/detail03.png": 7575,
	"./images/investment/icon01.png": 4365,
	"./images/investment/icon02.png": 2945,
	"./images/investment/icon03.png": 4775,
	"./images/investment/icon04.png": 2679,
	"./images/investment/support01.png": 6619,
	"./images/investment/support02.png": 1646,
	"./images/investment/support03.png": 7147,
	"./images/investment/support04.png": 6027,
	"./images/investment/text_bg01.png": 7660,
	"./images/investment/text_bg02.png": 8788,
	"./images/investment/text_bg03.png": 5227,
	"./images/logo.png": 4427,
	"./images/map/back.png": 2129,
	"./images/map/back01.png": 5986,
	"./images/map/header.png": 3382,
	"./images/map/header2.png": 6582,
	"./images/map/icon01.png": 7911,
	"./images/map/icon02.png": 8661,
	"./images/map/icon03.png": 743,
	"./images/map/map.png": 4561,
	"./images/map/particle.png": 5264,
	"./images/map/point01.png": 5865,
	"./images/map/tooltip.png": 3618,
	"./images/map/yuan.png": 182,
	"./images/map/yuan2.png": 9280,
	"./images/menu.png": 3325,
	"./images/nav/active.png": 2504,
	"./images/nav/inactive.png": 882,
	"./images/nav/nav01.png": 8664,
	"./images/nav/nav02.png": 7010,
	"./images/nav/nav03.png": 1764,
	"./images/nav/nav04.png": 4904,
	"./images/nav/nav05.png": 8793,
	"./images/qr-goods.png": 4805,
	"./images/qr-lodging.png": 9154,
	"./images/qr-scenicy.png": 1878,
	"./images/scenery01.png": 9279,
	"./images/scenery02.png": 7279,
	"./images/scenery03.png": 8310,
	"./images/scenery04.png": 6173,
	"./images/scenery05.png": 9119,
	"./images/scenery_bg.png": 4511,
	"./images/scenery_bg01.png": 9982,
	"./images/support.png": 6540,
	"./images/test-qr.jpg": 555,
	"./images/title.png": 4755,
	"./images/tour/address.png": 2473,
	"./images/tour/arrow.png": 476,
	"./images/tour/bg01.png": 2451,
	"./images/tour/bg02.png": 4035,
	"./images/tour/image.png": 828,
	"./images/tour/img_bg01.png": 9340,
	"./images/tour/img_bg02.png": 877,
	"./images/tour/img_bg03.png": 4065,
	"./images/tour/line_detail.png": 2749,
	"./images/tour/line_name.png": 3082,
	"./images/tour/line_price.png": 1950,
	"./images/tour/line_traffic.png": 9506,
	"./images/tour/map/point01.png": 1721,
	"./images/tour/map/point02.png": 7613,
	"./images/tour/subtitle01.png": 1000,
	"./images/tour/subtitle02.png": 5405,
	"./images/tour/subtitle03.png": 4010,
	"./images/video.png": 6178,
	"./images/video01.png": 9855,
	"./images/video02.png": 1535,
	"./images/wrap-left.png": 7602,
	"./images/wrap-right.png": 6823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9808;